import CryptoJS from "crypto-js";

// // Get the secret key from the .env file
const SECRET_KEY = "event-ehr-secret-key";
/**
 * Encrypt data before storing it in localStorage
 * @param {any} data - The data to be encrypted
 * @returns {string} - Encrypted string
 */
export const encryptData = (data: any): string => {
  if (!SECRET_KEY) {
    console.error("Encryption failed: SECRET_KEY is missing.");
    return "";
  }

  try {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
    if (!encrypted) throw new Error("Encryption returned empty string");
    return encrypted;
  } catch (error) {
    console.error("Error encrypting data:", error);
    return "";
  }
};

/**
 * Decrypt data retrieved from localStorage
 * @param {string} encryptedData - The encrypted string
 * @returns {any} - Decrypted data (parsed JSON object)
 */
export const decryptData = (encryptedData: string): any => {
  if (!SECRET_KEY) {
    console.error("Decryption failed: SECRET_KEY is missing.");
    return null;
  }
  
  try {
    if (!encryptedData) throw new Error("Encrypted data is empty");

    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedString) {
      throw new Error("Decryption resulted in an empty string");
    }

    return JSON.stringify(decryptedString); // FIXED: Parse instead of stringify if needed
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};
